module.exports = __webpack_public_path__ + "static/img/img_future.177f0cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img_future.png
// module id = gbGp
// module chunks = 1